import React, { useCallback, useRef, useState } from "react";
import { getDic } from '../assets/i18n/dictionary';
import Webcam from "react-webcam";
import Button from './Button';
import FormRow from "./FormRow";
import FormColumn from "./FormColumn";
import Box from '@mui/material/Box';

const Camera = ({
  configOptions,
  onPhoto,
  width,
  height,
  v3 = false,
  ...props
}) => {

  const webcamRef = useRef(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (onPhoto) {
      onPhoto(imageSrc);
    }
  }, [webcamRef]);

  return (
    <FormColumn>
      <FormRow>
        <div
          style={{
            width: width || 640,
            height: height || 480,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          <div
            style={{
              display: 'flex',
              position: 'absolute',
              alignSelf: 'center',
              justifyContent: 'center',
              height: height > 500 ? 350 : height * 0.7,
              width: width > 500 ? 250 : width * 0.5,
              border: '15px solid white',
              borderRadius: 150,
              opacity: 0.6,
              zIndex: 1,
            }}
          />
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            videoConstraints={{
              width: width || 960,
              height: height || 720,
              facingMode: "user",
            }}
            minScreenshotWidth={960}
            minScreenshotHeight={720}
            mirrored={true}
          />
        </div>
      </FormRow>
      <FormRow paddingTop={10} justifyContent='center'>
        <Button
          textColor={configOptions.buttonTextColor}
          background={configOptions.buttonBackgroundColor}
          maxWidth={v3 ? 400 : 200}
          text={`${getDic("tirar")} ${getDic("foto")}`}
          onPress={capture}
          v3={v3}
        />
      </FormRow>
    </FormColumn>
  );
};

export default Camera;
